export const COLUMN_SAMPLE_TIME = 'sampleTime';
export const COLUMN_REGISTERED_TIME = 'registeredTime';
export const COLUMN_SAMPLE_ID = 'sampleId';
export const COLUMN_SERVER_TIME = 'serverTime';
export const COLUMN_NODE_TIME = 'nodeTime';
